<template>
  <ParticularsSection
    v-if="surveys.length"
    :with-narrow-columns="true"
    title="H&M"
  >
    <div v-for="({ key, cells }, i) in surveys" :key="key" class="survey">
      <ParticularsCell
        v-for="cell in cells"
        :key="`${i}-${cell.label}`"
        :class="cell.key === 'date' && 'col-start-1'"
        :label="cell.label"
      >
        <p>{{ cell.value }}</p>
      </ParticularsCell>
    </div>
  </ParticularsSection>
</template>

<script>
import ParticularsSection from "@/components/ui/ParticularsSection.vue";
import ParticularsCell from "@/components/ui/ParticularsCell.vue";
import { extractCells } from "@/helpers/particulars";
import moment from "moment";

export default {
  name: "VesselParticularsHM",
  components: { ParticularsCell, ParticularsSection },
  props: {
    vessel: {
      type: Object,
      required: true,
    },
    excludeEmptyFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hullInspectionCells() {
      // sort hull inspections by latest date
      const hullInspections = [...this.vessel.hullInspections].sort((a, b) => {
        if (moment(a.date).isBefore(moment(b.date))) return 1;
        else if (moment(a.date).isAfter(moment(b.date))) return -1;
        else return 0;
      });

      return extractCells(
        hullInspections,
        [
          {
            label: "Date",
            key: "date",
            format: "date",
          },
          { label: "Activity", key: "activity" },
          { label: "Requirement", key: "requirement" },
          {
            label: "Next Due",
            key: "nextDue",
            format: "date",
          },
          { label: "Comments", key: "comments" },
        ],
        this.excludeEmptyFields
      );
    },
    surveys() {
      return [
        ...this.hullInspectionCells.map((cells, i) => ({
          key: `hull-inspection-${i}`,
          cells,
        })),
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.survey {
  display: contents;

  &:not(:last-child) {
    div:last-child {
      margin-bottom: 1rem;
    }
  }
}
</style>
